import { Suspense } from 'react'
import type { ReactNode} from 'react';

import { FullPageLoadingSpinner } from '@acre/design-system'

const AppSuspenseWrapper = ({ children }: { children: ReactNode }) => {
  return <Suspense fallback={<FullPageLoadingSpinner />}>{children}</Suspense>
}

export default AppSuspenseWrapper
